module.exports = __webpack_public_path__ + "img/weibiaoti.6e471858.png";